import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/home.vue'
import Welcome from './views/welcome.vue'
import { fluent } from './utils';

Vue.use(Router)


export const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "login" */ './views/login.vue')
    },
    {
      path: '/',
      component: Home,
      async beforeEnter(to, from, next) {
        if (Vue.store.state.me === null) {
          await Vue.store.dispatch('me')
        }
        next()
      },
      children: [
        {
          path: '1vs1/detect',
          component: () => import(/* webpackChunkName: "1vs1-detect" */ './views/1vs1/detect.vue'),
        },
        {
          path: '1vs1/compare',
          component: () => import(/* webpackChunkName: "1vs1-compare" */ './views/1vs1/compare.vue'),
        },
        {
          path: '1vsV/compare',
          component: () => import(/* webpackChunkName: "1vsV-compare" */ './views/1vsV/compare.vue'),
        },
        {
          path: 'bucket',
          component: () => import(/* webpackChunkName: "bucket-list" */ './views/bucket/list.vue'),
        },
        {
          path: 'user',
          component: () => import(/* webpackChunkName: "user-list" */ './views/user/list.vue'),
        },
        {
          path: 'department',
          component: () => import(/* webpackChunkName: "department-list" */ './views/department/list.vue'),
        },
        {
          path: 'computer',
          component: () => import(/* webpackChunkName: "computer-list" */ './views/computer/list.vue'),
        },
        {
          path: 'performanceMonitoring',
          component: () => import(/* webpackChunkName: "computer-list" */ './views/computer/performanceMonitoring.vue'),
        },
        {
          path: 'route-config',
          component: () => import(/* webpackChunkName: "routeConfig-list" */ './views/routeConfig/list.vue'),
        },
        {
          path: 'log/1v1',
          component: () => import(/* webpackChunkName: "log" */ './views/log/1v1/index.vue'),
        },
        {
          path: 'log/1vN',
          component: () => import(/* webpackChunkName: "log" */ './views/log/1vN.vue'),
        },
        {
          path: 'log/1vV',
          component: () => import(/* webpackChunkName: "log" */ './views/log/1vV/index.vue'),
        },
        {
          path: '',
          component: Welcome,
        }
      ]
    },
    {
      path: '*',
      redirect: '/'
    },
  ],
})

router.beforeEach((to, from, next) => {
  fluent(() => window.$vm.$Progress.start())
  next()
})

router.afterEach((to, from) => {
  fluent(() => window.$vm.$Progress.finish())
})
